type ConnectionData = {
  totalCount?: number;
  nodes?: unknown[];
  pageInfo?: unknown;
};

/**
 * Generic merge function for GraphQL connection types.
 * Preserves both totalCount and nodes fields when partial data is cached.
 *
 * Without this merge function, Apollo would replace the entire cached object,
 * potentially losing either totalCount or nodes depending on which query runs last.
 *
 * @param existing - The existing cached data
 * @param incoming - The incoming data from the query
 * @returns Merged data preserving both totalCount and nodes
 */
export const connectionMerge = (existing: ConnectionData = {}, incoming: ConnectionData = {}): ConnectionData => ({
  ...existing,
  ...incoming,
  nodes: incoming.nodes ?? existing.nodes,
});
